module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGMAAABjAgMAAADyVVYGAAAACVBMVEX///8Ao93vKy0M+RveAAAAKElEQVRIx2NYhQOsGJUZlRmVoUBmFIyCUUALEIoDhIzKjMqMypAvAwBF7jWSS5At0wAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/uis/assets/images/flags/Luxembourg.png
// module id = 590
// module chunks = 0